import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  standalone: true,
  selector: 'rl-icon',
  templateUrl: './icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, NgOptimizedImage, CommonModule, AngularSvgIconModule],
})
export class IconComponent {
  @Input() matIcon = '';
  @Input() rlnIcon = '';
  @Input() matIconOutlined = true;

  /**
   * Only works for rlnIcon, so if you need it for a matIcon, then add it to assets and use rlnIcon instead.
   */
  @Input() size: 'normal' | 'large' = 'normal';

  @HostBinding('style.width.px') get style_width_px() {
    return this.size === 'large' ? 48 : 18;
  }

  @HostBinding('style.height.px') get style_height_px() {
    return this.size === 'large' ? 48 : 18;
  }
}
